<template>
  <div id="app" class="flex flex-wrap h-full w-full items-center justify-center">
    <div class="flex h-screen w-screen items-center justify-center flex-wrap">
      <div class="flex h-screen w-0 md:w-1/2">
        <Candu v-if="!isMobile" />
      </div>
      <div class="flex flex-wrap h-screen w-full md:w-1/2 items-center justify-center overflow-auto">
        <div class="flex flex-wrap w-full items-center justify-center">
          <router-view />
        </div>
        <div class="flex w-full self-end">
          <div class="hireful-font-domus text-gray-400 w-full flex justify-center">
            © {{ currentYear }} hireful ltd. All rights reserved.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import utils from '@/mixins/utils'
import router from '@/router'
import Candu from '@/components/Candu'
import store from '@/store'

Vue.mixin(utils)

let currentRoute = null

router.beforeEach((to, from, next) => {
  currentRoute = to
  utils.methods.validateSession(to)
  next()
})

export default {
  name: 'app',
  components: {
    Candu
  },
  data: function () {
    return {
      hirefulHost: process.env.VUE_APP_HIREFUL_APP_HOST,
      currentRoute
    }
  },
  computed: {
    backgroundImageStyle () {
      return { backgroundImage: 'url(https://ewr-public.s3.eu-west-1.amazonaws.com/img/Modified_login.792da55d.png)' }
    },
    currentYear () {
      const dt = new Date()
      return dt.getFullYear()
    },
    isMobile () {
      return store.getters.isMobile
    }
  },
  methods: {
  },
  async beforeCreate () {
    const deviceData = await utils.methods.getDevice()
    if (deviceData && deviceData.device && deviceData.device.ismobile) {
      store.commit('setIsMobile', deviceData.device.ismobile)
    } else {
      store.commit('setIsMobile', false)
    }
  }
}
</script>

<style>
#app {
  font-family: 'Open Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

@font-face {
  font-family: Domus;
  src: url("~@/assets/fonts/Domus-Regular.otf") format("opentype");
  font-display: swap;
}

@font-face {
  font-family: 'Domus semibold';
  src: url("~@/assets/fonts/Domus-Semibold.otf") format("opentype");
  font-display: swap;
}

.hireful-font-domus {
  font-family: 'Domus', 'Open Sans', sans-serif;
}

.hireful-font-semibold {
  font-family: 'Domus semibold', 'Open Sans', sans-serif;
}

.he--login-bg {
  background-size: 100% 100%;
}

/* #beamerWithoutlogin {
  position: absolute;
  right: 2%;
  bottom: 0;
  font-weight: bold;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
} */
</style>
